<template>
    <ion-app>
        <!-- icons -->
        <icons/>
        <main-header ref="mainHeaderComponent"></main-header>
        <ion-router-outlet id="main" main>
            <!-- views -->
            <router-view></router-view>
        </ion-router-outlet>
    </ion-app>
</template>

<script>
    import Icons from '@/components/Icons';
    import MainHeader from '@/components/MainHeader';

    import SwipeListener from 'swipe-listener';
    import {mapGetters} from 'vuex';
    import {Capacitor} from '@capacitor/core';

    import Analytics from '@/services/Analytics';
    import PushNotifications from '@/services/PushNotifications';
    import Firestore from '@/services/Firestore';
    import Badge from '@/services/Badge';

    export default {
        name: 'App',
        components: {
            'icons': Icons,
            'main-header': MainHeader,
        },
        computed: {
            ...mapGetters(['isAuthenticated']),
        },
        methods: {
          checkModernAppleVariants() {
            let iOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
            let ratio = window.devicePixelRatio || 1;
            let screen = {
              width: window.screen.width * ratio,
              height: window.screen.height * ratio
            };
            let aspect = window.screen.width / window.screen.height
            //
            if (iOS && screen.width == 1125 && screen.height === 2436) {
              this.iPhoneXDetected = true;
              document.getElementById('notch').style.height="2.5em";
            } else if (iOS && aspect.toFixed(3) === "0.462") {
              this.iPhoneXDetected = true;
            }
            else {
              this.iPhoneXDetected = false;
            }
          }
        },
        created() {
            // get some global settings
            this.$store.dispatch('GLOBAL_AGREEMENTS_REQUEST');
            this.$store.dispatch('GLOBAL_ROLES_REQUEST');
            this.$store.dispatch('GLOBAL_YEARS_REQUEST');
            this.$store.dispatch('GLOBAL_PROVINCES_REQUEST');
            this.$store.dispatch('GLOBAL_AREAS_REQUEST');
            // fetch user profile if authenticated
            if (this.$store.getters.isAuthenticated) {
                this.$store.dispatch('profile/PROFILE_REQUEST')
            }
        },
        mounted() {
            setTimeout(() => {
                this.checkModernAppleVariants();

                // -------------------------- o
                // add firebase services
                // with capacitor mobile

                if (Capacitor.platform !== 'web') {
                    // add push notifications
                    PushNotifications.pushInit().then(() => {
                        // wait for push notifications to resolve
                        Firestore.firestoreInit();
                    });
                }

                // -------------------------- o
                // add go back button listener (for Android back button mostly)

                document.addEventListener("backbutton", () => {
                    this.$root.$emit('goingBack');
                    this.$router.go(-1);
                });

                // -------------------------- o
                // add swipe listener

//                let container = document.querySelector('#topOfDocument');
//                let listener = SwipeListener(container);
//                container.addEventListener('swipe', (e) => {
//                    if (e.detail.directions.right) {
//                        console.log('Swiped right.');
//                        this.$root.$emit('goingBack');
//                        this.$router.go(-1)
//                    }
//                });

                // -------------------------- o

            }, 500);
        }
    }
</script>

<style lang="scss">
    @import "assets/sass/variables";
    @import "assets/sass/helpers/mixins/breakpoint";

    ion-content {
        --overflow: hidden !important; // custom scroll
        @include media-breakpoint-up(md) {
            --overflow: auto !important; // native scroll
        }
    }

    ion-header {
        padding: 0 !important;
    }

    ion-alert {
        --max-width: 360px !important;
        --width: 85% !important;
    }

    ion-popover {
        --width: 250px !important;
    }
</style>
